import React, { useEffect, useRef, useState } from 'react';
import { useBootstrap } from '../context/BootstrapContext.jsx';
import { useLucideIcons } from '../hooks/usePageAssets.js';

const AuthSection = ({ showAdminLink = true }) => {
  const bootstrap = useBootstrap();
  const loginUrl = bootstrap?.routes?.login || '/login';
  const logoutUrl = bootstrap?.routes?.logout || '/logout';
  const adminUrl = bootstrap?.routes?.admin || '/admin';
  const user = bootstrap?.user_profile;
  const isSuperAdmin = Boolean(bootstrap?.is_super_admin);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useLucideIcons([menuOpen, isSuperAdmin, user?.picture]);

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    document.addEventListener('keyup', handleEscape);

    return () => {
      document.removeEventListener('click', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
      document.removeEventListener('keyup', handleEscape);
    };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [bootstrap?.authenticated]);

  const toggleMenu = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setMenuOpen((prev) => !prev);
  };

  const avatarInitial = (user?.name || user?.email || '?').charAt(0).toUpperCase();

  if (!bootstrap?.authenticated) {
    return (
      <div className="auth-section">
        <a href={loginUrl} className="auth-btn login-btn">
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google logo"
            className="google-logo"
          />
          Acceder con Google
        </a>
      </div>
    );
  }

  return (
    <div className="auth-section">
      <div className="user-menu-container" ref={menuRef}>
        <button
          type="button"
          className="user-menu-trigger"
          id="userIconBtn"
          aria-haspopup="true"
          aria-expanded={menuOpen}
          aria-controls="userDropdown"
          onClick={toggleMenu}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              toggleMenu(event);
            }
          }}
        >
          {user?.picture ? (
            <img src={user.picture} alt="Foto de perfil" className="user-avatar" />
          ) : (
            <span className="user-avatar user-avatar-fallback">{avatarInitial}</span>
          )}
          <i data-lucide={menuOpen ? 'chevron-up' : 'chevron-down'} className="menu-caret" />
        </button>
        <div className={`user-dropdown ${menuOpen ? 'show' : ''}`} id="userDropdown" role="menu">
          <div className="user-info">
            <img src={user?.picture} alt="Foto de perfil" className="user-avatar" />
            <span className="user-name">{user?.name}</span>
          </div>
          {isSuperAdmin && showAdminLink ? (
            <a href={adminUrl} className="dropdown-link admin-link" onClick={() => setMenuOpen(false)}>
              <i data-lucide="settings" />
              Panel Admin
            </a>
          ) : null}
          <a href={logoutUrl} className="dropdown-link logout-btn" onClick={() => setMenuOpen(false)}>
            <i data-lucide="log-out" />
            Cerrar Sesión
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthSection;
